<template>
  <v-dialog v-model="dialogStoreManager" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>Nhập kho ngày {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg5 md5 sm5>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0 ma-0>
                <v-checkbox label="Sử dụng máy quét mã vạch" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 v-if="useBarcodeReader">
                <v-text-field
                  label="Mã vận đơn"
                  ref="trancode"
                  v-model="currentItem.TransactionCode"
                  class="input-group--focused"
                  :rules="requireRules"
                  @keyup.enter="codeChanged"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 v-else>
                <v-autocomplete label="Mã vận đơn" ref="trancode" :items="suggestList" item-text="TransactionCode" item-value="TransactionCode"  v-model="currentItem.TransactionCode" class="input-group--focused" :rules="requireRules" @change="manualChanged" @keyup.enter="manualChanged"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.Weight"
                  :decimal="1"
                  label="Cân nặng (kg)"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeShip"
                  :decimal="1"
                  label="Phí ship"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeFragileGoods"
                  :decimal="1"
                  label="Phí gia cố"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeOther"
                  :decimal="1"
                  label="Phí khác"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-textarea
                  v-model="currentItem.StoreCNNote"
                  label="Ghi chú"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></v-textarea>
              </v-flex>
              <v-flex lg12 md12 sm12 offset-md-10 pa-0>
                <v-btn @click="manualChanged" :disabled="useBarcodeReader">Nhập</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg7 md7 sm7>
            <v-layout pl-4 pr-2 pt-12>
              <v-flex lg12 md12 sm12>
              <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :options.sync="pagination"
                  :server-items-length="total_rows"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr v-bind:class="{ 'warning-line': item.IsFragileGoods || item.IsCheck || item.OrderGuarantee}">
                      <td>{{ item.ID }}</td>
                      <td>{{ item.TransactionCode }}</td>
                      <td>
                        {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                        <br v-if="item.IsFragileGoods" />
                        {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                        <br v-if="item.IsCheck" />
                        {{ item.OrderGuarantee ? 'Bảo hiểm' : '' }}
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.Weight"
                          large
                          lazy
                          persistent
                          @save="saveItem({ID: item.ID, Weight: item.Weight})"
                        >
                          <div>{{ item.Weight | currency('', 1)}}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Weight"
                              :decimal="1"
                              label="Cân nặng (kg)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.FeeShip"
                          large
                          lazy
                          persistent
                          @save="saveItem({ID: item.ID, FeeShip: item.FeeShip})"
                        >
                          <div>{{ item.FeeShip | currency('¥', 1)}}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.FeeShip"
                              :decimal="1"
                              label="Phí ship"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.FeeFragileGoods"
                          large
                          lazy
                          persistent
                          @save="saveItem({ID: item.ID, FeeFragileGoods: item.FeeFragileGoods})"
                        >
                          <div>{{ item.FeeFragileGoods | currency('¥', 1)}}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.FeeFragileGoods"
                              :decimal="1"
                              label="Phí gia cố"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.FeeOther"
                          large
                          lazy
                          persistent
                          @save="saveItem({ID: item.ID, FeeOther: item.FeeOther})"
                        >
                          <div>{{ item.FeeOther | currency('¥', 1)}}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.FeeOther"
                              :decimal="1"
                              label="Phí khác"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="truncate">
                        <v-edit-dialog
                          :return-value.sync="item.StoreCNNote"
                          large
                          lazy
                          persistent
                          @save="saveItem({ID: item.ID, StoreCNNote: item.StoreCNNote})"
                        >
                          <v-tooltip top absolute right offset-overflow max-width="250" color="light-green lighten-5 black--text">
                            <template v-slot:activator="{ on }">
                                <span v-on="on">{{ item.StoreCNNote }}</span>
                            </template>
                            <span>{{ item.StoreCNNote }}</span>
                          </v-tooltip>
                          <template v-slot:input>
                            <v-textarea
                              v-model="item.StoreCNNote"
                              label="Ghi chú"
                              autofocus
                            ></v-textarea>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-center">
                        <v-icon small @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import { getCurrentTime } from "@/commons/utils";
import Filtering from "@/components/Filtering";
export default {
  name: "store-popup",
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      useBarcodeReader: false,
      lastTransactionCode: '',
      currentItem: {
        TransactionCode: "",
        FeeShip: 0,
        Weight: 0
      },
      filterData: [
        {
          column: "StoreCNImportDate",
          value: getCurrentTime(),
          condition: "d_equal"
        },
        {
          column: "Status",
          value: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
          condition: "equal"
        }
      ],
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Cảnh báo",
          sortable: false,
          filterable: false,
        },
        {
          text: "Câng nặng (kg)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí gia cố",
          value: "FeeFragileGoods",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ghi chú",
          value: "StoreCNNote"
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: {
        ...configs.PAGINATION,
        sortBy: ["ID"]
      },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      currentTime: getCurrentTime(),
      filterConditions: [],
      quickFilterConditions: [],
      viewName: "import_cn_store_list",
    };
  },
  props: ["dialogStoreManager"],
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.getListData();
      },
      deep: true
    },
    dialogStoreManager() {
      if (this.dialogStoreManager) {
        this.getListData();
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    items() {
      const lastItem = _.find(this.items, {'TransactionCode': this.lastTransactionCode});
      if(lastItem && (lastItem.IsFragileGoods || lastItem.IsCheck || lastItem.OrderGuarantee)) {
        this.playSound('/fire_alarm.mp3')
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.listOfDay.data,
      suggestList: state => state.orderTransaction.suggestList.data,
      total_rows: state => state.orderTransaction.listOfDay.total,
      loading: state => state.orderTransaction.loading
    })
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    deleteItem(id) {
      this.$emit("deleteItem", id);
    },
    saveItem(item) {
        this.$store.dispatch("orderTransaction/setDetail", {
          data: {...item},
          id: item.ID
        });
    },
    manualChanged() {
      if (this.currentItem.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentItem.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
        this.lastTransactionCode = this.currentItem.TransactionCode;
        this.$store.dispatch("orderTransaction/setDetail", {
          data: {
            ...this.currentItem,
            Status: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
            TransactionView: 'store_cn_popup'
          },
          param: {
            pagination: this.pagination,
            filter: this.filterData,
            quickFilter: []
          }
        });
        this.currentItem = {
          TransactionCode: "",
          FeeShip: 0,
          Weight: 0
        };
        this.$nextTick(() => this.$refs.trancode.focus());
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.getListData();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.getListData();
    },
    getListData() {
      var param = {
        pagination: this.pagination,
        filter: [
          ...this.filterConditions,
          {
            column: "StoreCNImportDate",
            value: getCurrentTime(),
            condition: "d_equal"
          },
          {
            column: "Status",
            value: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
            condition: "equal"
          }
        ],
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("orderTransaction/getListOfDay", param);
      this.$store.dispatch("orderTransaction/getListSuggest", {filter: [{
          column: "Status",
          value: [0,1],
          condition: "in",
        }]});
    },
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.getListData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getListData);
  }
};
</script>
<style scoped>
.warning-line {
  background-color: rgba(250, 117, 117, 0.726);
}
</style>
